var map;
var position_latitude;
var position_longitude;
var markersGroup;
var customIcon;

function initMap() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(load, load);
    }

    function load(position) {
        if (position.coords) {
            position_latitude = position.coords.latitude;
            position_longitude = position.coords.longitude;
        } else {
            position_latitude = -29.223114;
            position_longitude = -51.335427;
        }

        // Inicializar o mapa Leaflet
        map = L.map('map').setView([position_latitude, position_longitude], 12);

        // Adicionar camada de tiles
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '© OpenStreetMap contributors'
        }).addTo(map);

        // Criar ícone personalizado
        customIcon = L.icon({
            iconUrl: site_url + 'site/img/marker.png',
            iconSize: [30, 40],
            iconAnchor: [15, 40],
            popupAnchor: [0, -40]
        });

        // Adicionar listener para redimensionamento
        window.addEventListener('resize', () => {
            map.invalidateSize();
        });

        // Carregar marcadores
        window.onload = function () {
            $('.modalLoader').fadeIn();
            addMarkersToMap(map);
            $('.modalLoader').delay(4000).fadeOut();
        };
    }
}

function moveMapToMap(lat, lng, zoom) {
    map.setView([lat, lng], zoom);
}

function addMarkersToMap(map) {
    let form = $('[data-cep]');
    
    // Criar grupo de marcadores
    markersGroup = L.layerGroup().addTo(map);

    $.ajax({
        type: $(form).attr('method'),
        url: $(form).attr('action'),
        data: {
            latitude: position_latitude,
            longitude: position_longitude,
            '_token': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: "json",
        error: function () {
            Swal.fire({
                title: "OPS!",
                text: 'Servidor está temporariamente indisponível. Tente novamente mais tarde.',
                imageUrl: site_url + 'site/img/iconError.png',
                imageWidth: 76,
                imageHeight: 76
            });
        },
        success: function (json) {
            if (json.status) {
                let content = `<p>${jsi18n.have_found} <b>${json.total} ${jsi18n.results_installers}</b></p>`;
                $('.installers__resultQtd').html(content).fadeIn();

                $.each(json.experts, function (index, el) {
                    if (index == 0) {
                        moveMapToMap(el.lat, el.lng, 12);
                    }

                    var popupContent = '<div class="pin-marker">';
                    popupContent += '<div class="marker">';
                    popupContent += '<p><strong>' + el.title + '</strong></p>';
                    if (el.installer_type) {
                        popupContent += '<p>' + jsi18n.installer_type + ': ' + el.installer_type + '</p>';
                    }
                    if (el.phone) {
                        popupContent += '<p>' + jsi18n.phone + ': ' + el.phone + '</p>';
                    }
                    if (el.phone1) {
                        popupContent += '<p>' + jsi18n.phone + ' 1: ' + el.phone1 + '</p>';
                    }
                    if (el.phone2) {
                        popupContent += '<p>' + jsi18n.phone + ' 2: ' + el.phone2 + '</p>';
                    }
                    if (el.email) {
                        popupContent += '<p>E-mail: ' + el.email + '</p>';
                    }
                    popupContent += '<p>' + jsi18n.adress + ': ' + el.address + '</p>';
                    if (el.opening_hours) {
                        popupContent += '<p>' + jsi18n.opening_hours + ': ' + el.opening_hours + '</p>';
                    }
                    popupContent += '</div>';
                    popupContent += '</div>';

                    addMarkerToGroup(markersGroup, el.lat, el.lng, popupContent);
                });

            } else {
                Swal.fire({
                    title: "OPS!",
                    text: json.message,
                    imageUrl: site_url + 'site/img/iconError.png',
                    imageWidth: 76,
                    imageHeight: 76
                });
            }
        }
    });
}

function addMarkerToGroup(group, lat, lng, popupContent) {
    var marker = L.marker([lat, lng], {
        icon: customIcon
    });
    
    marker.bindPopup(popupContent, {
        maxWidth: 300,
        className: 'custom-popup'
    });
    
    marker.addTo(group);
}

function getExpertsByCEP() {
    $('[data-cep]').on('submit', (e) => {
        e.preventDefault();

        $('.modalLoader').fadeIn();

        let form = $('[data-cep]');

        $.ajax({
            url: form.attr('action'),
            method: form.attr('method'),
            data: form.serialize() + '&_token=' + $('meta[name="csrf-token"]').attr('content'),
            success: (response) => {
                $('.modalLoader').fadeOut();
                response = JSON.parse(response);

                // Limpar marcadores existentes
                if (markersGroup) {
                    markersGroup.clearLayers();
                }

                if (response.status) {
                    let content = `<p>${jsi18n.have_found} <b>${response.total} ${jsi18n.results_installers}</b></p>`;
                    $('.installers__resultQtd').html(content).fadeIn();

                    // Criar novo grupo de marcadores
                    markersGroup = L.layerGroup().addTo(map);

                    $.each(response.experts, function (index, el) {
                        if (index == 0) {
                            moveMapToMap(el.lat, el.lng, 12);
                        }

                        var popupContent = '<div class="pin-marker">';
                        popupContent += '<div class="marker">';
                        popupContent += '<p><strong>' + el.title + '</strong></p>';
                        if (el.installer_type) {
                            popupContent += '<p>' + jsi18n.installer_type + ': ' + el.installer_type + '</p>';
                        }
                        if (el.phone) {
                            popupContent += '<p>' + jsi18n.phone + ': ' + el.phone + '</p>';
                        }
                        if (el.phone1) {
                            popupContent += '<p>' + jsi18n.phone + ' 1: ' + el.phone1 + '</p>';
                        }
                        if (el.phone2) {
                            popupContent += '<p>' + jsi18n.phone + ' 2: ' + el.phone2 + '</p>';
                        }
                        if (el.email) {
                            popupContent += '<p>E-mail: ' + el.email + '</p>';
                        }
                        popupContent += '<p>' + jsi18n.adress + ': ' + el.address + '</p>';
                        if (el.opening_hours) {
                            popupContent += '<p>' + jsi18n.opening_hours + ': ' + el.opening_hours + '</p>';
                        }
                        popupContent += '</div>';
                        popupContent += '</div>';

                        addMarkerToGroup(markersGroup, el.lat, el.lng, popupContent);
                    });

                } else {
                    let content = `<p>${jsi18n.have_found} <b>0 ${jsi18n.results_installers}</b></p>`;
                    $('.installers__resultQtd').html(content).fadeIn();

                    if (response.lat && response.lng) {
                        moveMapToMap(response.lat, response.lng, 12);
                    }

                    Swal.fire({
                        title: "Ops...",
                        text: response.message,
                        type: 'warning'
                    });
                    console.log(response.message);
                }
            },
            error: (response) => {
                $('.modalLoader').fadeOut();
                console.log('CEP Length', $('#cep').val());
                if ($('#cep').val().length > 0) {
                    Swal.fire({
                        title: "Erro!",
                        text: 'Não foi possível conectar aos serviços',
                        type: 'error'
                    });
                }
                console.log(response);
            }
        });
    });
}

$(document).ready(function () {
    initMap();
    getExpertsByCEP();
});